import { createRoot } from 'react-dom/client';
import App from './jsx/App.jsx';
import './styles/Website.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
